// Password Protection Configuration
export const PASSWORD_PROTECTION_CONFIG = {
  // Authentication settings - tiered passwords
  PASSWORDS: {
    FULL_ACCESS: process.env.REACT_APP_PASSWORD || 'K101!',
    CAREER_QUEST_ONLY:
      process.env.REACT_APP_CAREER_QUEST_PASSWORD || 'testLessons101!',
  },

  // Permission levels
  PERMISSION_LEVELS: {
    FULL_ACCESS: 'FULL_ACCESS',
    CAREER_QUEST_ONLY: 'CAREER_QUEST_ONLY',
  },

  // Routes accessible with CAREER_QUEST_ONLY permission
  CAREER_QUEST_ALLOWED_ROUTES: [
    '/dashboard',
    '/dashboard/home',
    '/dashboard/modules/career-quest',
    '/career-quest/challenges',
    '/career-quest/career-maker',
    '/tools/career-quest',
    '/tools/alien-baby-maker',
  ],

  // Routes that should be explicitly blocked for CAREER_QUEST_ONLY permission
  // (even if they start with an allowed route prefix)
  CAREER_QUEST_BLOCKED_ROUTES: [
    '/dashboard/modules/fairy-tale',
    '/dashboard/modules/music-studio',
    '/dashboard/modules/coding-from-scratch',
    '/dashboard/ai',
  ],

  // Routes that should redirect to dashboard home for all authenticated users
  // (menu items that don't have actual pages yet)
  REDIRECT_TO_DASHBOARD_HOME: [
    '/teacher-resources',
    '/create',
    '/support',
    '/profile',
    '/schedule',
    '/students',
    '/files',
    '/settings',
  ],

  // Session timeout settings (in milliseconds)
  SESSION_DURATION:
    parseInt(process.env.REACT_APP_SESSION_DURATION) || 60 * 60 * 1000, // 1 hour default

  // Warning settings (in milliseconds)
  WARNING_THRESHOLD:
    parseInt(process.env.REACT_APP_WARNING_THRESHOLD) || 5 * 60 * 1000, // 5 minutes default

  // Monitoring intervals (in milliseconds)
  SESSION_CHECK_INTERVAL:
    parseInt(process.env.REACT_APP_SESSION_CHECK_INTERVAL) || 60000, // 1 minute
  TIME_DISPLAY_UPDATE_INTERVAL:
    parseInt(process.env.REACT_APP_TIME_DISPLAY_UPDATE_INTERVAL) || 1000, // 1 second for smooth countdown

  // Local storage keys
  AUTH_KEY: 'kinetic101_auth',
  SESSION_EXPIRY_KEY: 'kinetic101_session_expiry',
  PERMISSION_LEVEL_KEY: 'kinetic101_permission_level',

  // UI settings
  SHOW_SESSION_INDICATOR:
    process.env.REACT_APP_SHOW_SESSION_INDICATOR !== 'false', // true by default
};

// Helper functions for time calculations
export const TIME_HELPERS = {
  // Convert milliseconds to minutes
  msToMinutes: ms => Math.floor(ms / (1000 * 60)),

  // Convert milliseconds to seconds
  msToSeconds: ms => Math.floor((ms % (1000 * 60)) / 1000),

  // Format time as MM:SS
  formatTime: ms => {
    const minutes = Math.floor(ms / (1000 * 60));
    const seconds = Math.floor((ms % (1000 * 60)) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  },

  // Get session expiry time from now
  getSessionExpiry: () =>
    Date.now() + PASSWORD_PROTECTION_CONFIG.SESSION_DURATION,

  // Check if session is expiring soon
  isExpiringSoon: remainingTime =>
    remainingTime > 0 &&
    remainingTime < PASSWORD_PROTECTION_CONFIG.WARNING_THRESHOLD,
};

// Helper function to check if a route is allowed for a permission level
export const isRouteAllowed = (path, permissionLevel) => {
  if (
    permissionLevel === PASSWORD_PROTECTION_CONFIG.PERMISSION_LEVELS.FULL_ACCESS
  ) {
    return true;
  }

  if (
    permissionLevel ===
    PASSWORD_PROTECTION_CONFIG.PERMISSION_LEVELS.CAREER_QUEST_ONLY
  ) {
    // First check if the route is explicitly blocked
    if (
      PASSWORD_PROTECTION_CONFIG.CAREER_QUEST_BLOCKED_ROUTES.some(
        blockedRoute =>
          path === blockedRoute || path.startsWith(blockedRoute + '/')
      )
    ) {
      return false;
    }

    // Check if the route matches any of the allowed Career Quest routes
    // For exact matches or routes that start with allowed routes
    return PASSWORD_PROTECTION_CONFIG.CAREER_QUEST_ALLOWED_ROUTES.some(
      allowedRoute => {
        // Exact match
        if (path === allowedRoute) {
          return true;
        }
        // For /dashboard, only allow /dashboard/home as a sub-route
        if (allowedRoute === '/dashboard') {
          return path === '/dashboard/home' || path === '/dashboard/';
        }
        // For other routes, allow the route and its sub-routes
        return path.startsWith(allowedRoute + '/');
      }
    );
  }

  return false;
};
